import { Content_6_9_A } from "data/task/v1/6-9-A";
import getConfirmedThoughtmapState from "./getConfirmedThoughtMapState";

export default async function get_6_9_A_RawData(patientId: number) {
  try {
    const confirmedThoughtmapState = await getConfirmedThoughtmapState(
      patientId
    );
    // console.log("[TEST]", thoughtmapState);
    return {
      taskId: `6-9-A`,
      content: Content_6_9_A(
        confirmedThoughtmapState?.intermediateBeliefKeyList
      ),
    };
  } catch (error) {
    // 에러 핸들링
    console.error("Error in get_6_5_A_RawData:", error);
    throw error; // 또는 에러에 대한 처리를 진행할 수 있음
  }
}
